var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "97px",
    viewBox: "0 0 97 97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DA3B3E40-5DE7-457C-A30D-310724F777DD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 97,
    height: 97,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6584902,0 C30.4825241,0 36.8251568,6.34263271 36.8251568,14.1666667 C36.8251568,18.2684685 35.0819157,21.9631146 32.2958851,24.5501532 C39.8784607,27.9453273 44.2581604,35.8879827 45.2767106,47.9332891 L45.3169832,48.4346405 L45.3420881,48.7643816 L45.2905805,49.091041 C44.6414156,53.2080236 42.3237555,55.9071691 38.6179195,56.5597567 L38.3373833,56.6048537 L37.9376037,56.6344267 C24.0487018,56.6766174 21.0158898,56.6773987 7.87158047,56.63677 L7.11662308,56.634426 L6.71407968,56.6044165 C2.9362973,56.0500394 0.62333536,53.3738678 0.0499841745,49.2819428 L0.0111402356,48.9800173 L0,48.4346405 C0.938473859,36.1082118 5.3338162,27.9922381 13.0209198,24.5482448 C10.2350646,21.9631146 8.49182351,18.2684685 8.49182351,14.1666667 C8.49182351,6.34263271 14.8344562,0 22.6584902,0 Z M22.6584911,28.3333333 C12.3230547,28.3333333 6.79741859,34.7009456 5.67278214,48.5788935 C5.89839916,50.1610993 6.39112832,50.7722417 7.36743886,50.9685129 C20.8700096,51.0105058 23.8289259,51.0104958 37.6910399,50.9684821 C38.7597861,50.7603488 39.3365373,50.1066531 39.6392737,48.5184933 C38.5035083,34.6824689 32.9789216,28.3333333 22.6584911,28.3333333 Z M22.6584902,5.66666667 C17.9640698,5.66666667 14.1584902,9.47224629 14.1584902,14.1666667 C14.1584902,18.861087 17.9640698,22.6666667 22.6584902,22.6666667 C27.3529106,22.6666667 31.1584902,18.861087 31.1584902,14.1666667 C31.1584902,9.47224629 27.3529106,5.66666667 22.6584902,5.66666667 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD10-1-Login-&-Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Create-Profile-Invalid",
    transform: "translate(-587.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(349.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(238.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_placeholder"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-2",
    fill: "#DADCDD",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Account",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)",
    id: "baseline-person-24px"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Colours-/-dark-grey",
    transform: "translate(11.333333, 5.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path-2",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colours-/-dark-grey-Colours-/-inactive-grey",
    mask: "url(#mask-4)",
    fill: "#969CA1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.333333, -5.666667)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 68,
    height: 68
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 68 0 68 68 0 68"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user_placeholder.a7e4992784e8422d01b33b51254c4c84.svg";
export { ForwardRef as ReactComponent };